var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.833,70.077v115.845c0,1.079-0.245,2.109-0.674,3.029l-62.608-73.093l62.497-49.044 C218.551,67.796,218.833,68.9,218.833,70.077z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.461,192.889c-0.589,0.147-1.19,0.245-1.827,0.245H44.378c-0.638,0-1.239-0.098-1.815-0.245 l64.067-72.37l19.782,15.281c0.552,0.417,1.214,0.638,1.876,0.638c0.662,0,1.337-0.221,1.889-0.662l20.554-16.127L213.461,192.889 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.761,116.766l-63.908,72.186c-0.441-0.92-0.687-1.938-0.687-3.029V70.077 c0-0.981,0.196-1.901,0.552-2.747L101.761,116.766z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.971,63.001l-84.707,66.483L42.355,63.16c0.65-0.184,1.325-0.294,2.024-0.294h167.256 C212.1,62.866,212.542,62.915,212.971,63.001z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.2df368249da15c30eaf2a485d8f40a65.svg";
export { ForwardRef as ReactComponent };